<div cdkDropList class="domain-list" (cdkDropListDropped)="updateOrderOfDomainsWithApplianceCapacity($event)">
  <div class="line domain-box"
    *ngFor="let domainConfigurationWithApplianceCapacity of domainsWithApplianceCapacityList; let domainConfigurationIndex = index;"
    [cdkDragDisabled]="!domainConfigurationWithApplianceCapacity.isActive"
    [matTooltipDisabled]="domainConfigurationWithApplianceCapacity.isActive"
    [matTooltip]="'APPLICATIONS.ACTIVATION_MESSAGE_APPLIANCE' | translate" cdkDrag>
    <!-- allow use to have the domainKey inside a variable which ease readibility -->
    <ng-container *ngIf="domainConfigurationWithApplianceCapacity.domainKey; let currentDomainKey">
      <ng-container *ngIf="domainsByKey[currentDomainKey]; let currentDomainDataref">
        <span class="material-icons" *ngIf="domainConfigurationWithApplianceCapacity.isActive">
          import_export
        </span>
        <!-- checkbox to activate/deactive a specific domain -->
        <mat-checkbox class="checkbox-default-appliance"
          [checked]="domainConfigurationWithApplianceCapacity.isActive ? true : false"
          (change)="toggleDefaultAppliance(domainConfigurationWithApplianceCapacity, $event, domainConfigurationIndex)"
          [matTooltip]="'APPLICATIONS.CHECKBOX_DEFAULT_APPLIANCE' | translate">
        </mat-checkbox>

        <!-- form-field to select an appliance for an activated domain -->
        <mat-form-field
          class="form-field-m {{ domainConfigurationWithApplianceCapacity.isActive && domainConfigurationWithApplianceCapacity.defaultApplianceId === null ? 'mat-form-field-invalid' : ''}}">
          <mat-label>{{(currentDomainDataref | translateReference).translatedName}}</mat-label>
          <mat-select [(value)]="domainConfigurationWithApplianceCapacity.defaultApplianceId"
            [disabled]="!domainConfigurationWithApplianceCapacity.isActive" (valueChange)="modelChanged.emit()"
            required>
            <ng-container
              *ngIf="appliancesListByDomainMarket[currentDomainKey] ? appliancesListByDomainMarket[currentDomainKey][currentMarketKey] : null; let domainMarketAppliancesList">
              <mat-option *ngFor="let appliance of domainMarketAppliancesList" [value]="appliance.key">
                {{(appliance| translateReference).translatedName}}
                <span
                  *ngIf="getDefaultApplianceStatuts(currentDomainKey, appliance.key) ==='PUBLISHED'; else applianceNotPublishedBlock">
                  <i class="far fa-check-circle green-icon "></i>
                </span>
                <ng-template #applianceNotPublishedBlock>
                  <span>
                    <i class="fas fa-times red-icon"></i>
                  </span>
                </ng-template>
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <p style="margin: 16px;">{{ getDefaultApplianceStatuts(currentDomainKey,
          domainConfigurationWithApplianceCapacity.defaultApplianceId) | translate}}</p>

        <!-- form-field to select the capacity for appliances which required it  -->
        <mat-form-field class="form-field-s"
          *ngIf="getDefaultApplianceCapacities(domainConfigurationWithApplianceCapacity.defaultApplianceId, domainConfigurationWithApplianceCapacity); else emptyApplianceFormField; let defaultApplianceCapacities">
          <mat-label>{{'APPLICATIONS.APPLIANCE_CAPACITY' | translate }}</mat-label>
          <mat-select *ngIf="domainConfigurationWithApplianceCapacity.capacity"
            [(value)]="domainConfigurationWithApplianceCapacity.capacity.quantity">
            <mat-option *ngFor="let capacity of defaultApplianceCapacities" [value]="capacity.quantity">
              {{capacity.quantity}} {{getUnitLabel(capacity.unit.key)}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- display an empty form field in case one of the other domain has an appliance with capacity, to ensure checkboxes vertical alignment -->
        <ng-template #emptyApplianceFormField>
          <mat-form-field class="form-field-s daf-form-field-no-underline"
            *ngIf="hasSomeApplianceWithCapacityActivated">
            <input [hidden]="true" matInput />
          </mat-form-field>
        </ng-template>

        <!-- do not display checkboxes while appliance has not been chosen for activated domain -->
        <ng-container *ngIf="domainConfigurationWithApplianceCapacity.defaultApplianceId">

          <!-- checkbox to activate/deactivate ugc service -->
          <mat-form-field class="form-field-xs daf-form-field-no-underline daf-form-field-service-checkbox">
            <mat-label> {{ SERVICES_TRANSLATION_KEYS.LABEL_UGC | translate }} </mat-label>
            <input [hidden]="true" [(ngModel)]="domainConfigurationWithApplianceCapacity.isUgcEnabled" matInput />
            <mat-checkbox [(ngModel)]="domainConfigurationWithApplianceCapacity.isUgcEnabled"
              [matTooltip]="SERVICES_TRANSLATION_KEYS.CHECKBOX_TOOLTIP_UGC | translate">
            </mat-checkbox>
          </mat-form-field>

          <!-- checkbox to activate/deactive adaptation perso service -->
          <mat-form-field class="form-field-m daf-form-field-no-underline  daf-form-field-service-checkbox">
            <mat-label> {{ SERVICES_TRANSLATION_KEYS.LABEL_PERSO_ADAPTATION | translate }} </mat-label>
            <input [hidden]="true"
              [(ngModel)]="domainConfigurationWithApplianceCapacity.isPersonalizedAdaptationEnabled" matInput />
            <mat-checkbox [(ngModel)]="domainConfigurationWithApplianceCapacity.isPersonalizedAdaptationEnabled"
              [matTooltip]="SERVICES_TRANSLATION_KEYS.CHECKBOX_TOOLTIP_PERSO_ADAPTATION | translate">
            </mat-checkbox>
          </mat-form-field>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>